<template> 
    <div class="font">
        <v-row justify="center" class="extra-bottom-area">
            <v-col cols="12" sm="8" md="8" lg="6">
                <div class="stage-title">{{stage.Name && stage.Name.toUpperCase()}}</div>
                <div class="intro" v-if="!IsPrimary">
                    <div>To finalise your application, you will need two references. A reference is a written statement by someone who is willing to speak on your behalf to tell us why you should receive a GO-PEF Scholarship. We ask you to nominate two people who will tell us how great you are:</div>
                    <ul>
                        <li>A community reference</li>
                        <li>A school reference</li>
                    </ul>
                    <div>We will ask you for their contact details and we will contact them directly.</div>
                </div>
                <div class="intro" v-if="IsPrimary">
                    <div>To finalise your application, you will need a school reference. A reference is a written statement by someone who is willing to speak on your child’s behalf to tell us why they should receive a GO-PEF Scholarship. We ask you to nominate someone from your child’s school who will tell us how great they are. We will ask you for their contact details and we will contact them directly.</div>
                </div>
                
                <v-form ref="form1" v-if="!IsPrimary">
                    <div class="referee-form">
                        <div class="referee-title">Community Referee *</div>
                        <div class="referee-text">Please nominate a person who has known you for at least 12 months. This person CANNOT be a member of your family or a relative. Your referee should be someone who can tell us how wonderful you are and confirm that you will make the most of your scholarship. <b>We are NOT looking for someone to confirm your Aboriginality</b>. We are looking for someone who will tell us you are great!</div>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    label="First Name *"
                                    :value="communityReferee['FirstName']"
                                    @change="updateReferee({type: 'Community Referee', prop: 'FirstName', value: capitalizeString($event)})"
                                    :rules="notEmpty"
                                    outlined
                                    hide-details
                                    v-model="ComFirstName"
                                ></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                    label="Last Name *"
                                    :value="communityReferee['LastName']"
                                    @change="updateReferee({type: 'Community Referee', prop: 'LastName', value: capitalizeString($event)})"
                                    :rules="notEmpty"
                                    outlined
                                    hide-details
                                    v-model="ComLastName"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    label="Email *"
                                    :value="communityReferee['Email']"
                                    @change="updateReferee({type: 'Community Referee', prop: 'Email', value: $event})"
                                    :rules="validEmail"
                                    outlined
                                    @select="disableSelection($event)"
                                    v-model="ComEmail"
                                ></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                    label="Repeat Email *"
                                    v-model="repeatCommunityEmail"
                                    :rules="checkCommunityEmail"
                                    outlined
                                    @select="disableSelection($event)"
                                    
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    label="Phone Number *"
                                    :value="communityReferee['Phone']"
                                    @change="updateReferee({type: 'Community Referee', prop: 'Phone', value: $event})"
                                    :rules="phoneNumber"
                                    outlined
                                    @select="disableSelection($event)"
                                    v-model="ComPhone"
                                ></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                    label="Repeat Phone Number *"
                                    v-model="repeatCommunityPhone"
                                    :rules="checkCommunityPhone"
                                    outlined
                                    @select="disableSelection($event)"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    label="How do you know this person? *"
                                    :value="communityReferee['How_do_you_know_the_referee__c']"
                                    @change="updateReferee({type: 'Community Referee', prop: 'How_do_you_know_the_referee__c', value: $event})"
                                    :rules="notEmpty&&lengthCheckMinMax"
                                    outlined
                                    hide-details
                                    v-model="ComKnowThisPerson"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-select
                                    :items="['Yes', 'No']"
                                    :value="communityReferee['Have_you_asked_this_person_to_be_referee__c']"
                                    @change="updateReferee({type: 'Community Referee', prop: 'Have_you_asked_this_person_to_be_referee__c', value: $event})"
                                    label="Have you asked this person to be your referee? *"
                                    outlined
                                    hide-details
                                    v-model="ComAsked"
                                ></v-select>
                            </v-col>
                        </v-row>
                    </div>
                </v-form>
                
                <v-form ref="form2">
                    
                    <div class="referee-form">
                        <div class="referee-title">School Referee *</div>
                        <div class="referee-text">Your school referee must work at your current school. It should be your Principal, or another staff member who knows you well. Their email address must be a school email address (ending in .edu.au).</div>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    label="First Name *"
                                    :value="schoolReferee['FirstName']"
                                    @change="updateReferee({type: 'School Referee', prop: 'FirstName', value: capitalizeString($event)})"
                                    :rules="notEmpty"
                                    outlined
                                    hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                    label="Last Name *"
                                    :value="schoolReferee['LastName']"
                                    @change="updateReferee({type: 'School Referee', prop: 'LastName', value: capitalizeString($event)})"
                                    :rules="notEmpty"
                                    outlined
                                    hide-details
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    label="Email *"
                                    :value="schoolReferee['Email']"
                                    @change="updateReferee({type: 'School Referee', prop: 'Email', value: $event})"
                                    :rules="validEduEmail"
                                    outlined
                                    @select="disableSelection($event)"
                                ></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                    label="Repeat Email *"
                                    v-model="repeatSchoolEmail"
                                    :rules="checkSchoolEmail"
                                    outlined
                                    @select="disableSelection($event)"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    label="Phone Number *"
                                    :value="schoolReferee['Phone']"
                                    @change="updateReferee({type: 'School Referee', prop: 'Phone', value: $event})"
                                    :rules="phoneNumber"
                                    outlined
                                    @select="disableSelection($event)"
                                ></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                    label="Repeat Phone Number *"
                                    v-model="repeatSchoolPhone"
                                    :rules="checkSchoolPhone"
                                    outlined
                                    @select="disableSelection($event)"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-select
                                    :items="schoolRoles"
                                    :value="schoolReferee['What_is_their_role_at_your_school__c']"
                                    @change="updateReferee({type: 'School Referee', prop: 'What_is_their_role_at_your_school__c', value: $event})"
                                    label="What is their role at your school?"
                                    outlined
                                    hide-details
                                ></v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-select
                                    :items="['Yes', 'No']"
                                    :value="schoolReferee['Have_you_asked_this_person_to_be_referee__c']"
                                    @change="updateReferee({type: 'School Referee', prop: 'Have_you_asked_this_person_to_be_referee__c', value: $event})"
                                    label="Have you asked this person to be your referee? *"
                                    outlined
                                    hide-details
                                ></v-select>
                            </v-col>
                        </v-row>
                    </div>
                    
                </v-form>
            </v-col>
        </v-row>
        <v-row class="sticky-footer" justify="center" align="center">
            <v-col cols="12" sm="3" md="3" lg="2">
                <v-btn class="button btn-font" outlined @click="$router.push({name: 'application.dashboard'})" color="#4d4d4d" large>BACK</v-btn>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="4">
                <v-btn class="button btn-font" :disabled="loading" @click="showConfirmationPopup" color="#ea7f1d" large>{{loading? 'SAVING...' : 'SAVE RESPONSES'}}</v-btn>
            </v-col>
        </v-row>

        <v-dialog persistent v-model="showConfirmation" class="mx-auto" max-width="410">
            <v-card class="dialog-style dialog-margin">
                <div class="tips">
                    We will contact your referees directly and ask them to endorse your application.
                    <br><br>
                    Before you save your answers to this section, confirm that you have asked these people to be your referee, and are confident they will endorse you positively for a GO-PEF Scholarship.
                    <br><br>
                    <p style="color:#B11116;font-weight:bold;">If you don’t ask your referee to endorse your application, there is a chance they may not want to do it. Your application could be affected. So, please ask!</p>
                </div>
                <v-card-actions class="margin-top">
                    <v-btn large text class="popup-button go-back-button" @click="showConfirmation = false"><span class="go-back">GO BACK</span></v-btn>
                    <v-btn large color="#ea7f1d" class="popup-button leave-button" :disabled="loading" @click="save"><span class="leave">SAVE</span></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import Client from '../client.js'
import {phoneRule, hasLengthRule} from '../utils/validationRules'

export default {
    props: {
        stage_key: String,
        application_id: [String, Number]
    },
    computed: {
        stage() {
            const stages = this.$store.getters['stage/stages'];
            if(stages.length === 0) return {};
            return stages.find(s => s.Id === this.stage_key);
        },
        questions() {
            const questionsWithAnswer = this.$store.getters['stage/questionsWithAnswer'];
            if(!questionsWithAnswer[this.stage_key]) return [];
            return questionsWithAnswer[this.stage_key];
        },
        notEmpty() {
            return [v => {
                return Boolean(v) && v.trim().length > 0;
            }]
        },
        validEmail() {
            return [v => /.+@\S+\.\S+/.test(v) || 'This is not a valid email address']
        },
        validEduEmail() {
            return [
                    v => /.+@\S+\.\S+/.test(v) || 'This is not a valid email address', 
                    v => /.+@(\S+\.edu\.au|\S*gofoundation\.org\.au)$/.test(v&&v.toLowerCase()) || 'Must be a valid school teacher\'s email ending in .edu.au'
                ]
        },
        phoneNumber() {
            return [
                hasLengthRule,
                phoneRule,
            ]
        },
        communityReferee() {
            const questionsWithAnswer = this.$store.getters['stage/questionsWithAnswer'];
            if(!questionsWithAnswer[this.stage_key]) return {};
            const communityReferee = questionsWithAnswer[this.stage_key].find(r => r['Type__c']&&r['Type__c'].toLowerCase() === 'community referee');
            return communityReferee || {};
        },
        schoolReferee() {
            const questionsWithAnswer = this.$store.getters['stage/questionsWithAnswer'];
            if(!questionsWithAnswer[this.stage_key]) return {};
            const schoolReferee = questionsWithAnswer[this.stage_key].find(r => r['Type__c']&&r['Type__c'].toLowerCase() === 'school referee');
            return schoolReferee || {};
        },
        checkCommunityEmail() {
            console.log(this.repeatCommunityEmail);
            console.log(this.communityReferee['Email']);
            console.log(this.ComEmail);
            return [
                () => this.repeatCommunityEmail == this.communityReferee['Email'] || 'Email is not the same'
            ]
        },
        checkCommunityPhone() {
            return [
                () => this.repeatCommunityPhone == this.communityReferee['Phone'] || 'Phone is not the same'
            ]
        },
        checkSchoolEmail() {
            return [
                () => this.repeatSchoolEmail == this.schoolReferee['Email'] || 'Email is not the same'
            ]
        },
        checkSchoolPhone() {
            return [
                () => this.repeatSchoolPhone == this.schoolReferee['Phone'] || 'Phone is not the same'
            ]
        },
        lengthCheckMinMax() {
            return [v => !v ? !!v || 'The field cannot be empty': v.length >= 1 && v.length <= 100 || 'Please Shorten your answer into 100 characters']
        },
    },
    data: function () {
        return {
            loading: false,
            schoolRoles: ['Principal', 'Deputy Principal', 'School teacher', 'Aboriginal Liaison Officer', 'Other member of staff'],
            repeatCommunityEmail: null,
            repeatCommunityPhone: null,
            repeatSchoolEmail: null,
            repeatSchoolPhone: null,
            showConfirmation: false,
            IsPrimary: false,
            //Dummy Community
            ComFirstName: null,
            ComLastName: null,
            ComEmail: null,
            ComPhone: null,
            ComKnowThisPerson: null,
            ComAsked: null,

        }
    },
    async beforeMount() {
        let client = Client();
        await client.get('me/profile').then(res => {
            //this.profile = res.data;
            //console.log('me/profile'+res.data);
            console.log(res.data);
            if(res.data.school_level == 'primary'){
                this.IsPrimary = true;
                console.log('this.IsPrimary = true');
                
                //create dummy community
                console.log('Do Dummy Community');
                this.ComFirstName = 'Dummy Community';
                this.ComLastName= 'For Primary School';
                this.ComEmail= 'asd@asd.com';
                this.ComPhone = '0411112222';
                this.ComKnowThisPerson = 'Mie Mie Mie! And we know each other -_-!';
                this.ComAsked = 'Yes';
                this.repeatCommunityEmail= 'asd@asd.com';
                this.repeatCommunityPhone = '0411112222';
                this.communityReferee['Email'] = 'asd@asd.com';
                this.communityReferee['FirstName'] = 'Dummy Community';
                this.communityReferee['LastName'] = 'For Primary School';
                this.communityReferee['Phone'] = '0411112222';
                this.communityReferee.How_do_you_know_the_referee__c = 'Mie Mie Mie! And we know each other -_-!';
                
                console.log('before moumt');
                console.log(this.questions);
                this.$forceUpdate();
            }
        }, () => {});     
    },
    mounted: function() {
        if(this.questions.length) {
            const community = this.questions.find(item => item.Type__c === 'Community Referee') || {};
            if(this.repeatCommunityEmail && this.repeatCommunityEmail.length > 0 ){   
                this.updatedummy();
            }else {
                this.repeatCommunityEmail = community.Email;
                this.repeatCommunityPhone = community.Phone;
            }
            const school = this.questions.find(item => item.Type__c === 'School Referee') || {};
            this.repeatSchoolEmail = school.Email;
            this.repeatSchoolPhone = school.Phone;
        }
        console.log(this.repeatCommunityEmail);

    },
    methods: {
        updatedummy(){
            /*
            if(this.IsPrimary){
                console.log('update dummy')
                this.$refs.form.resetValidation()
                this.ComEmail= 'asd@asd.com';
                this.ComPhone = '0411112222';
                this.repeatCommunityEmail= 'asd@asd.com';
                this.repeatCommunityPhone = '0411112222';
                this.communityReferee['Email'] = 'asd@asd.com';
                this.communityReferee['Phone'] = '0411112222';
                this.$forceUpdate();
            }
            */
        },
        capitalizeString(value) {
            if(value) {
                value = value.charAt(0).toUpperCase() + value.substring(1);
            }
            return value;
        },
        disableSelection(e) {
            this.updatedummy();
            e.target.selectionStart = e.target.selectionEnd;
        },
        updateReferee({type, prop, value}) {
            this.updatedummy();
            
            this.$store.commit('stage/updateReferee', {stageId: this.stage_key, type, prop, value});
        },
        validate() {
            this.updatedummy();
            console.log('questions');
            console.log(this.questions);
            //console.log('form');
            //console.log(this.$refs.form);
            
            if(this.IsPrimary){
                console.log('vali primary');
                return this.$refs.form2.validate();
            }else{
                console.log('vali all');
                return this.$refs.form1.validate() && this.$refs.form2.validate();
            }
            
            //console.log(this.$refs.form);
            //return this.$refs.form.validate();
        },
        showConfirmationPopup() {
            if(!this.validate()) return;
            this.showConfirmation = true;
        },
        async save() {
            this.updatedummy();
            if(!this.validate()) return;
            this.loading = true;
            const answers = this.questions;
            const referees = answers
                .filter(a => a['Type__c']&&a['Type__c'].toLowerCase() === 'community referee' || a['Type__c']&&a['Type__c'].toLowerCase() === 'school referee')
                .map(a => ({
                    ...a,
                    Id: a.Id,
                    Scholarship_Application__c: this.application_id,
                    FirstName: a['FirstName'],
                    LastName: a['LastName'],
                    Email: a['Email'],
                    Phone: a['Phone'],
                    Type__c: a['Type__c'],
                    How_do_you_know_the_referee__c: a.How_do_you_know_the_referee__c,
                    What_is_their_role_at_your_school__c: a.What_is_their_role_at_your_school__c,
                    Have_you_asked_this_person_to_be_referee__c: a.Have_you_asked_this_person_to_be_referee__c,
                }))
            const client = Client();
            client.post(`/references/referees`, {
                answers: referees
            }).then(() => {
                this.$router.push({name: 'application.dashboard'});
                this.$store.commit('loading/push', {id: this.stage_key, message: 'Saving referees...'});
                this.$store.dispatch('stage/fetchQuestionsWithAnswer', {stageId: this.stage_key, appId: this.application_id});
                // this.$store.dispatch('stage/fetchStages', {appId: this.application_id});
                client.post(`/stages/${this.stage_key}/status`, {
                    Stage__c: this.stage_key,
                    Scholarship_Application__c: this.application_id,
                    Status__c: 'Completed'
                }).then(() => {
                    this.$store.commit('loading/remove', {id: this.stage_key});
                    this.$store.commit('stage/updateStageStatus', {stageId: this.stage_key, status: 'Completed'})
                }, () => this.$store.commit('loading/remove', {id: this.stage_key}))
            }, err => {
                this.loading = false;
                this.$alert(err.response.data.message);
                // this.$store.commit('loading/remove', {id: this.stage_key});
            })
            
            // this.$router.push({name: 'application.dashboard'});
            // this.$store.commit('loading/push', {id: this.stage_key, message: 'Saving referees...'});
        },
        // findChildQuestions(q) {
        //     const questionsWithAnswer = this.$store.getters['stage/questionsWithAnswer'];
        //     if(!questionsWithAnswer[this.stage_key]) return [];
        //     const children = questionsWithAnswer[this.stage_key].filter(d => d.Parent_Question__c && d.Parent_Question__c === q.Id);
        //     return children;
        // },
        // updateAnswer({qid, answer}) {
        //     this.$store.commit('stage/updateAnswer', {stageId: this.stage_key, questionId: qid, answer});
        // }
    }
}
</script>
<style lang="scss" scoped>
.stage-title {
    text-align: center;
    font-size: 30px;
    font-weight: 600;
    font-family: $body-font-family;
    margin-bottom: 28px;
}
.font {
    font-family: $secondary-font;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
}
.intro {
    margin-bottom: 40px;
    font-family: $secondary-font;
    font-size: 14px;
    line-height: 1.43;
}
.sticky-footer {
    box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.2);
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: white;
}
.button {
    width: 100%;
    color: white;
    font-family: $btn-font;
}
.referee-title {
    font-family: Hind;
    font-size: 16px;
    line-height: 1.25;
    margin-bottom: 10px;
}
.referee-text {
    font-family: $helper-font;
    font-size: 12px;
    line-height: 1.5;
    color: #3a3a3a;
    margin-bottom: 3px;
}
.referee-form {
    margin-bottom: 28px;
}
.extra-bottom-area {
    margin-bottom: 120px;
}
.dialog-style{
    width: 408px;
    height: 410px;
}
.tips{
    padding: 40px 38px 20px 30px;
    width: 408px;
    height: 320px;
    font-family: Hind;
}
.popup-button{
  width: 160px;
  height: 53px;
  border-radius: 3px;
  margin: 0 auto 0px auto;
}
.leave-button{
  background-color: #ea7f1d;
}
.go-back-button{
    border: solid 2px #4d4d4d;
}
.leave{
    width: 130px;
    height: 23px;
    @extend .form-secondary-text;
    color: #ffffff;
}
.go-back {
    width: 119px;
    height: 23px;
    @extend .form-secondary-text;
    color: #4d4d4d;
}
.form-secondary-text{
  font-family: Poppins;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1px;
  text-align: center;
}
.margin-top {
    margin-top: 20px;
}
</style>
